import { Rule, Tag,Link } from './index';
export class LibraryResult {
  rules: Array<Rule>;
  tags: Array<Tag>;
  links: Array<Link>;
}
